var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPigNafil = function SvgPigNafil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.539,
    height: 30.539,
    viewBox: "0 0 8.08 8.08",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M124.02 94.747a3.917 3.917 0 0 1-3.916 3.916 3.917 3.917 0 0 1-3.917-3.916 3.917 3.917 0 0 1 3.917-3.917 3.917 3.917 0 0 1 3.917 3.917z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.206879,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.14 94.497a2.638 1.79 0 0 1-2.638 1.79 2.638 1.79 0 0 1-2.638-1.79 2.638 1.79 0 0 1 2.638-1.79 2.638 1.79 0 0 1 2.639 1.79z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.0556376,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.037 94.608a1.335 1.388 0 0 1-1.335 1.389 1.335 1.388 0 0 1-1.335-1.389 1.335 1.388 0 0 1 1.335-1.388 1.335 1.388 0 0 1 1.335 1.388z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.0614895,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.805 94.365h.459c.045 0 .081.19.081.425s-.036.424-.081.424h-.46c-.045 0-.081-.19-.081-.424 0-.235.036-.425.082-.425z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.0531216,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.122 92.671s-.331.14-.473.244c-.147.106-.382.378-.382.378h.726s-.054-.24-.026-.357c.023-.099.155-.265.155-.265z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.0062071,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.275 93.511c-.004.014-.152-.072-.173-.19-.017-.091.214-.188.22-.181-.011-.03-.484.008-.41.341.03.133.165.279.165.279l.087-.14z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.00817256,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.936 95.408 1.208.052s.312-.122.245-.07c-.47.36-.387 1.441-.245 1.435v0h-1.001c.087 0-.142-.6-.154-.752z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      strokeDasharray: "none",
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.358 95.443h1.026c.046 0 .082.255.082.572v.22c0 .297-.087.573-.036.573h-.897c-.046 0 .053-.305-.117-.572l-.14-.221c-.17-.268.036-.572.082-.572z",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.00817256,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.246 93.991a.238.238 0 0 1-.237.238.238.238 0 0 1-.238-.238.238.238 0 0 1 .238-.237.238.238 0 0 1 .237.237z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.00853296,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.692 93.131c.548-.186 1.026-.08 1.456 0 .038.007.069.04.069.089 0 .049-.032.098-.069.088-.544-.137-1.03-.137-1.456 0-.036.012-.069-.04-.069-.088 0-.05.033-.076.069-.089z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 0.00689167,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.65 94.87 1.832.913v.093l-.203-.093h-1.63zm0-.198 1.832.914v.099l-1.832-.914zm0-.205 1.832.919v.101l-1.832-.922zm0-.198 1.832.92v.098l-1.832-.919zm0-.191 1.832.913v.099l-1.832-.92zm0-.2.87.436v-.437h.962v1.01l-1.832-.91Z",
    style: {
      fontSize: 8,
      lineHeight: 0.65,
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      fill: "green",
      strokeWidth: 0.352416
    },
    transform: "translate(-116.064 -90.707)"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPigNafil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pigNafil.aa3a863c.svg";
export { ForwardRef as ReactComponent };